import { Image } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const Footer = () => {
  const { language } = useLanguage();
  return (
    <footer className="border-t border-border py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Image className="w-4 h-4" />
            <span>SchoolPix</span>
            <span>·</span>
            <span>© {new Date().getFullYear()}</span>
          </div>
          <p className="text-xs text-muted-foreground">
            {language === 'de'
              ? 'Professionelle Schulfotografie leicht gemacht'
              : 'Professional school photography made easy'}
          </p>
        </div>
      </div>
    </footer>
  );
};
